import React, { useState } from 'react';
import { trainingApi } from '../../lib/api';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { ModuleEditor, emptyModule } from './RegisterDialog';

const clean = (m) => ({
  module_id: m.module_id || null,
  module_no: m.module_no || null,
  types: m.types || [],
  other_type: (m.types || []).includes('Altro') ? (m.other_type || null) : null,
  area: m.area || null,
  key_actions: m.key_actions || null,
  hours: m.hours === '' || m.hours == null ? null : parseFloat(m.hours),
  objectives: (m.objectives || []).filter(o => (o || '').trim()),
  next_check_date: m.next_check_date || null,
});

export default function ModuleFormDialog({ registerId, register, meta, module, onClose, onSaved }) {
  const isEdit = !!module;
  const [mod, setMod] = useState(() => module
    ? { ...module, objectives: [...(module.objectives || []), '', '', ''].slice(0, 3) }
    : emptyModule());
  const [saving, setSaving] = useState(false);
  const idx = isEdit
    ? (register.modules || []).findIndex(x => x.module_id === module.module_id)
    : (register.modules || []).length;

  const persist = async (modules, okMsg) => {
    setSaving(true);
    try {
      await trainingApi.updateRegister(registerId, { modules });
      toast.success(okMsg);
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Salvataggio fallito');
    } finally {
      setSaving(false);
    }
  };

  const save = () => {
    const others = (register.modules || []).map(clean);
    const modules = isEdit
      ? others.map((x, i) => (i === idx ? clean(mod) : x))
      : [...others, clean(mod)];
    persist(modules, isEdit ? 'Modulo aggiornato' : 'Modulo aggiunto');
  };

  const remove = () => {
    if (!window.confirm('Eliminare questo modulo dal registro?')) return;
    persist((register.modules || []).filter(x => x.module_id !== module.module_id).map(clean), 'Modulo eliminato');
  };

  return (
    <Dialog open onOpenChange={v => { if (!v) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="module-form-dialog">
        <DialogHeader>
          <DialogTitle>{isEdit ? `Modifica modulo ${idx + 1}` : 'Nuovo modulo formativo'}</DialogTitle>
          <DialogDescription>
            La data "prossimo controllo" del registro si aggiorna automaticamente dalla prossima verifica dell'ultimo modulo.
          </DialogDescription>
        </DialogHeader>
        <ModuleEditor idx={idx} mod={mod} meta={meta} onChange={setMod} />
        <DialogFooter className="flex-wrap gap-2">
          {isEdit && (
            <Button variant="outline" size="sm" className="h-9 text-red-600 border-red-200 mr-auto"
                    onClick={remove} disabled={saving} data-testid="module-form-delete-btn">
              <Trash2 className="w-3.5 h-3.5 mr-1.5" /> Elimina modulo
            </Button>
          )}
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={saving} data-testid="module-form-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin mr-1.5" /> : null}
            {isEdit ? 'Salva modulo' : 'Aggiungi modulo'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
